import React from 'react'
import {isEmpty} from 'lodash'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import EditUser from './EditUser'
import BackButton from '../UI/BackButton'
import UserNotFound from './UserNotFound'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'

import Resource from '../../stores/resource'
const UserStore = Resource('users')

class EditUserPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      user: {},
      error: '',
      loading: true
    }
  }

  componentDidMount() {
    UserStore.find(this.props.match.params.id)
    .then((result) => this.setState({user: result.data, loading: false}))
    .catch((error) => this.setState({
      user: {},
      error: errors.unpack(error),
      loading: false
    }))
  }

  _closeErrorDialog = () => this.setState({error: ''})

  render() {
    const {
      user,
      error,
      loading
    } = this.state

    if (loading) return <LinearLoader />
    if (isEmpty(user)) return <UserNotFound/>

    return (
      <section>
        <header>
          <PageTitle>
            Edit User
          </PageTitle>
        </header>

        <EditUser user={user} />
        <br/>
        <BackButton/>

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}>
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }

}

export default EditUserPage



// WEBPACK FOOTER //
// ./src/components/Users/EditUserPage.jsx